import { render, staticRenderFns } from "./CardPromotion.vue?vue&type=template&id=cd89476e&"
import script from "./CardPromotion.vue?vue&type=script&lang=js&"
export * from "./CardPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports